import { CheckCircle } from 'lucide-react';
const SuccessAnimation = ({ message = 'Success!' }) => (
  <div className="text-center py-8 animate-scale-in">
    <div className="w-20 h-20 bg-pw-on-success rounded-full flex items-center justify-center mx-auto mb-4 animate-scale-check">
      <CheckCircle className="w-12 h-12 text-pw-success" />
    </div>
    <h3 className="text-xl font-semibold text-pw-text">{message}</h3>
  </div>
);
export default SuccessAnimation;
